import React, { Component } from 'react';
import { Controlled } from 'react-codemirror2';

require('codemirror/lib/codemirror.css');
require('codemirror/mode/javascript/javascript');

const defaultOptions = {
  theme: 'material',
  lineNumbers: true,
  lineWrapping: true
};

class CodeMirror extends Component {
  render() {
    const { value, onChange, options, mode = 'javascript' } = this.props;

    return <Controlled options={{ ...defaultOptions, ...options, mode }} value={value} onBeforeChange={onChange} />;
  }
}

export default CodeMirror;
